import { render } from "./ManageRegistView.vue?vue&type=template&id=268b166b"
import script from "./ManageRegistView.vue?vue&type=script&lang=js"
export * from "./ManageRegistView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__